<template>
  <div class="custom-modal-wrapper">
    <button @click="showModal = true" class="button button--primary">
      <slot name="trigger">Open Modal</slot>
    </button>
    <CustomModal
      :visible="showModal"
      :showPrev="showPrev"
      :showNext="showNext"
      @close="handleClose"
      @prev="handlePrev"
      @next="handleNext"
    >
      <template slot="header">
        <slot name="header">Custom Modal Titel</slot>
      </template>
      <template slot="default">
        <slot name="default">
          <p>Default Content...</p>
        </slot>
      </template>
      <template slot="btnPrevTxt">
        <slot name="btnPrevTxt">Schließen</slot>
      </template>
      <template slot="btnNextTxt">
        <slot name="btnNextTxt">Ok!</slot>
      </template>
    </CustomModal>
  </div>
</template>
<script>
import CustomModal from '@/components/generic/CustomModal.vue'

export default {
  name: 'CustomModalWrapper',
  components: {
    CustomModal
  },
  props: {
    onNext: {
      type: Function,
      default: () => alert('Weiter-Button geklickt!')
    },
    onPrev: {
      type: Function,
      default: () => alert('Zurück-Button geklickt!')
    },
    showPrev: {
      type: Boolean,
      default: true
    },
    showNext: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showModal: false
    }
  },
  methods: {
    handleClose () {
      this.showModal = false
    },
    handlePrev () {
      this.onPrev()
    },
    handleNext () {
      this.onNext()
    }
  }
}
</script>
